const ConfiguredSectionPlaceholder = () => {
  return (
    <div className="flex items-center space-x-3 mt-3 px-2 sm:px-10">
      <div className="w-6 h-6 rounded-full bg-gray-300 animate-pulse" />
      <p className="text-gray-500 font-normal text-sm">Loading Configuration</p>
    </div>
  );
};

export default ConfiguredSectionPlaceholder;
